/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getExportInternal} from '../api'

 export const useQueryGetExportInternal = createReactQueryHook('getExportInternal', getExportInternal)
